//COMPONENTS
import ModalDefault from "../ModalDefault";
import InputBox from "../InputBox";
import SelectBox from "../SelectBox/SelectBox";

import { StyledBtn } from "../../styles/Buttons";
import { StyledFormFooter } from "./styled";

//LIBS
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {useForm} from "react-hook-form";

//RESOLVER
import { newTechSchema } from "../../schemas/schemas";

//CONTEXT
import { useContext } from "react";
import { TechContext } from "../../context/TechContext";


const DetailsModal = ({closeModal, tech})=>{

    const { deleteTechnology, submitUpdate } = useContext(TechContext);

    const { register, handleSubmit, formState:{errors}} = useForm({
        mode: "onBlur",
        resolver: yupResolver(newTechSchema)
    });

    return(
        <ModalDefault callback={handleSubmit(submitUpdate)} title="Detalhes da Tecnologia" closeModal={closeModal}>
            <InputBox
                label="Nome" name="tech-name"
                placeholder="Nome da tecnologia" type="text"
                register={register("title")} errors={errors.title}
                value={tech.title}
            />
            <SelectBox
                label="Nome do projeto" name="tech-name"
                register={register("status")} errors={errors.title}
            >
                <option value={tech.status}>{tech.status}</option>
                {
                    tech.status !== "Iniciante" &&  <option value="Iniciante">Iniciante</option>
                }
                {
                    tech.status !== "Intermediário" &&  <option value="Intermediário">Intermediário</option>
                }
                {
                    tech.status !== "Avançado" &&  <option value="Avançado">Avançado</option>
                }
            </SelectBox>

            <StyledFormFooter>
                <StyledBtn type="submit" BGcolor="var(--color-primary)" size="65%">Salvar Alterações</StyledBtn>
                <StyledBtn type="button" onClick={()=>deleteTechnology()} size="30%">Deletar</StyledBtn>
            </StyledFormFooter>
        </ModalDefault>
    )
    
}

export default DetailsModal;